/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { Typography, Box, Divider, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useTheme } from '@emotion/react';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import { formatPrice } from '../../utils';
import ReciverDropdown from '../../components/dropdowns/reciverDropdown';
import TimeDropdown from '../../components/dropdowns/timeDropdown';
import WhatsAppMsgService from '../../services/whatsAppMsgService';
import ViewWhatsAppMsgModal from '../../components/modals/whatsAppMsg/viewWhatsAppMsgModal';

const WhatsAppMsgs = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isEn = i18n.language === 'en';
    const tableHeadingStyle = { fontWeight: 'bold', backgroundColor: theme.palette.customGrey.tableHeading, cursor: 'pointer' };
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [msgs, setMsgs] = useState([]);
    const [msgsCount, setMsgsCount] = useState(0);
    const [selectedMsg, setSelectedMsg] = useState({});

    const [selectedReciver, setSelectedReciver] = useState(null);
    const [selectedTime, setSelectedTime] = useState({
        time: 'today',
        value: t('today')
    });
    const [sortState, setSortState] = useState({ sortBy: '', order: '' });

    const [openView, setOpenView] = useState(false);

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const tableContainerRef = useRef(null);
    const isFirstRender = useRef(true);

    const [isLoading, setIsLoading] = useState(false);


    const onSort = (sort) => {
        let order = '';
        if (sort === sortState.sortBy || sortState.sortBy === '') {
            switch (sortState.order) {
                case '':
                    order = 'asc';
                    break;
                case 'asc':
                    order = 'desc';
                    break;
                case 'desc':
                    order = '';
                    break;
                default:
                    order = '';
                    break
            }
        }

        setSortState({ sortBy: order === '' ? '' : sort, order });
    };

    const sortIcon = () => {
        let icon = <></>;
        switch (sortState.order) {
            case 'asc':
                icon = <ArrowDownwardOutlinedIcon fontSize="small" />;
                break;
            case 'desc':
                icon = <ArrowUpwardOutlinedIcon fontSize="small" />;
                break;
            default:
                icon = <ArrowDownwardOutlinedIcon fontSize="small" sx={{ color: 'transparent' }} />;
                break
        }

        return icon;
    };

    const handleOpenView = (notification) => {
        setSelectedMsg(notification);
        setOpenView(true);
    };;
    const handleCloseView = () => setOpenView(false);

    const handleString = (str) => {
        if (str === t("driver")) return "driver";
        else if (str === t("user")) return "user";
        else if (str === t("page")) return "page";
    };

    const fetchMsgs = async (page = 1, reciver = '') => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const filters = {
                reciver: handleString(reciver),
                ...sortState,
                ...selectedTime
            };
            const data = await WhatsAppMsgService.fetch(page, filters);
            const { whatsAppMsgs, count } = data;
            setMsgsCount(count);

            if (whatsAppMsgs.length === 0) {
                setHasMore(false);
                if (page === 1) {
                    setMsgs([]);
                }
            } else {
                setMsgs((prevs) => (page === 1 ? whatsAppMsgs : [...prevs, ...whatsAppMsgs]));
            }
        } catch (error) {
            console.error('Error fetching messages:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const resetFilter = () => {
        setSelectedReciver(null);
        setHasMore(true)
        setSelectedTime({
            time: 'today',
            value: t('today')
        });
        if (page !== 1) setPage(1);
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (page === 1) fetchMsgs(page, selectedReciver);
    }, [page]);

    useEffect(() => {
        if (page !== 1) {
            isFirstRender.current = true;
            setPage(1);
        }
        fetchMsgs(1, selectedReciver);
    }, [selectedReciver, sortState, selectedTime]);

    const handleScroll = (event) => {
        const container = event.currentTarget;

        if (container.scrollTop + container.clientHeight >= container.scrollHeight - 50) {
            if (hasMore && !isLoading) {
                fetchMsgs(page + 1, selectedReciver);
                setPage(prevPage => prevPage + 1);
            }
        }
    };


    return (
        <Box sx={{
            p: 2,
            backgroundColor: theme.palette.secondary.main,
            width: '100%',
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <ViewWhatsAppMsgModal open={openView} handleClose={handleCloseView} whatsAppMsgId={selectedMsg.id} />
            </Box>

            {/* Filter row */}
            {
                isTablet ? <Box
                    sx={{
                        mb: 2,
                        border: 1,
                        borderColor: theme.palette.customGrey.borderInput,
                        backgroundColor: 'white',
                        borderRadius: 1,

                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: 50,
                    }}>
                        <Box sx={{ px: 2 }}>
                            <FilterAltOutlinedIcon />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box sx={{
                            alignContent: 'center',
                            height: 50,
                            width: '90%'
                        }}>
                            <TimeDropdown
                                isFilter={true}
                                selectedTime={selectedTime}
                                setSelectedTime={setSelectedTime}
                            />
                        </Box>
                    </Box>

                    <Divider />

                    <Box sx={{
                        alignContent: 'center',
                        height: 50,
                        width: '100%'
                    }}>
                        <ReciverDropdown
                            isFilter={true}
                            selectedReciver={selectedReciver}
                            setSelectedReciver={setSelectedReciver}
                        />
                    </Box>

                    <Divider />

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: 50,
                    }}>
                        <Box sx={{
                            alignContent: 'center',
                            width: '60%'
                        }}>
                            <Typography variant="body1" sx={{ mx: 1 }}>
                                {t('totalMsgs')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(msgsCount)}</span>
                            </Typography>
                        </Box>

                        <Divider orientation="vertical" />
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                color: theme.palette.text.red,
                                px: 2,
                                cursor: 'pointer',
                            }}
                            onClick={resetFilter}
                        >
                            <ReplayOutlinedIcon />
                            <Box width={3}></Box>
                            <Typography variant="subtitle2">{t('resetFilter')}</Typography>
                        </Box>
                    </Box>



                </Box>
                    :
                    <Box
                        sx={{
                            mb: 2,
                            display: 'flex',
                            alignItems: 'center',
                            border: 1,
                            borderColor: theme.palette.customGrey.borderInput,
                            backgroundColor: 'white',
                            borderRadius: 1,
                            height: 60,
                        }}
                    >
                        <Box sx={{ px: 2 }}>
                            <FilterAltOutlinedIcon />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box width={'40%'}>
                            <TimeDropdown
                                isFilter={true}
                                selectedTime={selectedTime}
                                setSelectedTime={setSelectedTime}
                            />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box width={'20%'}>
                            <ReciverDropdown
                                isFilter={true}
                                selectedReciver={selectedReciver}
                                setSelectedReciver={setSelectedReciver}
                            />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box sx={{
                            alignContent: 'center',
                            width: '20%'
                        }}>
                            <Typography variant="body1" sx={{ mx: 1 }}>
                                {t('totalMsgs')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(msgsCount)}</span>
                            </Typography>
                        </Box>

                        <Divider orientation="vertical" />

                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                color: theme.palette.text.red,
                                px: 2,
                                cursor: 'pointer',
                            }}
                            onClick={resetFilter}
                        >
                            <ReplayOutlinedIcon />
                            <Box width={3}></Box>
                            <Typography variant="subtitle2">{t('resetFilter')}</Typography>
                        </Box>
                    </Box>
            }

            {/* Scrollable Table with Sticky Header */}
            <TableContainer
                component={Paper}
                ref={tableContainerRef}
                onScroll={handleScroll}
                sx={{
                    boxShadow: 'none',
                    border: 1,
                    borderColor: theme.palette.customGrey.borderInput,
                    borderRadius: 2,
                    height: 'calc(100vh - 160px)',
                    overflowY: 'auto',
                }}
            >
                <Table stickyHeader aria-label="simple table">
                    <TableHead
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                        }}
                    >
                        <TableRow>
                            <TableCell align={isEn ? 'left' : 'right'}
                                onClick={() => onSort('id')} sx={tableHeadingStyle}>
                                <Box sx={{ display: 'flex' }} >
                                    {t('id')}
                                    {sortState.sortBy === 'id' && sortIcon()}
                                </Box>
                            </TableCell>

                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}
                                onClick={() => onSort('reciver')}>
                                <Box sx={{ display: 'flex' }} >
                                    {t('reciver')}
                                    {sortState.sortBy === 'reciver' && sortIcon()}
                                </Box></TableCell>


                            <TableCell align={isEn ? 'left' : 'right'} sx={{ ...tableHeadingStyle, cursor: 'auto' }}>
                                {t('content')}
                            </TableCell>

                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}
                                onClick={() => onSort('createdAt')}>
                                <Box sx={{ display: 'flex' }} >
                                    {t('createdAt')}
                                    {sortState.sortBy === 'createdAt' && sortIcon()}
                                </Box></TableCell>

                            <TableCell align={isEn ? 'left' : 'right'} sx={{ ...tableHeadingStyle, cursor: 'auto' }}>
                                {t('actions')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {msgs.map((msg, index) => (
                            <TableRow
                                key={msg.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align={isEn ? 'left' : 'right'} component="th" scope="row">{msg.id}</TableCell>
                                <TableCell align={isEn ? 'left' : 'right'}>{t(msg.reciver)}</TableCell>
                                <TableCell
                                    align={isEn ? 'left' : 'right'}
                                    sx={{
                                        maxWidth: isTablet ? '100px' : '250px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}
                                    title={msg.content}
                                >
                                    {msg.content}
                                </TableCell>
                                <TableCell align={isEn ? 'left' : 'right'}>{msg.createdAt}</TableCell>
                                <TableCell align={isEn ? 'left' : 'right'}>
                                    <Box sx={{
                                        display: 'inline-flex',
                                        border: 1,
                                        borderColor: theme.palette.customGrey.borderInput,
                                        backgroundColor: theme.palette.secondary.main,
                                        borderRadius: 1,
                                    }}>
                                        <Box sx={{
                                            px: 1.5,
                                            pt: 0.6,
                                            pb: 0.25,
                                            cursor: 'pointer'
                                        }} onClick={() => handleOpenView(msg)}>
                                            <RemoveRedEyeOutlinedIcon fontSize='small'
                                                sx={{ color: theme.palette.text.primary }} />
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default WhatsAppMsgs;
